/**
 * The tool palette.
 *
 * Deliberately short. Panning is not a tool -- you drag, the way you would on a
 * map -- and neither is naming a room: click it with Select and type the name.
 * Scale is not a tool either, because the extractor derives it and what matters
 * here is the relationship between things, not the exact metres.
 *
 * Everything cut from this list was a mode the user had to know about before
 * they could do the obvious thing.
 */

export type Tool = 'select' | 'wall' | 'door' | 'window' | 'opening';

export interface ToolDefinition {
  id: Tool;
  label: string;
  /** Single-key shortcut. */
  key: string;
  hint: string;
}

export const TOOLS: ToolDefinition[] = [
  {
    id: 'select',
    label: 'Select',
    key: 'v',
    hint: 'Click a wall, corner or room to select it. Drag a corner to move it, drag anywhere else to pan.',
  },
  {
    id: 'wall',
    label: 'Wall',
    key: 'w',
    hint: 'Click for each corner. Hold Shift to lock to 45°, type a number to set an exact length, Esc or double-click to finish.',
  },
  { id: 'door', label: 'Door', key: 'd', hint: 'Click a wall to cut a door into it.' },
  { id: 'window', label: 'Window', key: 'n', hint: 'Click a wall to cut a window into it.' },
  {
    id: 'opening',
    label: 'Opening',
    key: 'o',
    hint: 'Click a wall to cut a doorless opening into it.',
  },
];

export const toolByKey = new Map(TOOLS.map((tool) => [tool.key, tool.id]));
